import { render, staticRenderFns } from "./headConfig.vue?vue&type=template&id=7537b95e&scoped=true"
import script from "./headConfig.vue?vue&type=script&lang=js"
export * from "./headConfig.vue?vue&type=script&lang=js"
import style0 from "./headConfig.vue?vue&type=style&index=0&id=7537b95e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7537b95e",
  null
  
)

export default component.exports